export const documentLogin = {
  DOCUMENT_PLACEHOLDER: 'X.XXX.XXX',
  Continue: 'Continuar',
  Document: 'C.I',
  Identification: 'Identificación',
  'Invalid document': 'CI inválida',
  'Please, confirm your document to continue':
    'Por favor, confirme su CI para continuar',
  'Please, inform a valid document': 'Por favor, libere un CI válido',
  'Unable to find your account': 'No pudimos encontrar su cuenta',
  'Validated successfully!': '¡Validado correctamente!',
};
